// AUTO-GENERATED FILE - DO NOT EDIT
// Run `bun run genIcons` instead.

/* istanbul ignore file */
/* eslint-disable */

import AddParts from '@/assets/icons/add-parts.svg'
import Add from '@/assets/icons/add.svg'
import Cancelled from '@/assets/icons/cancelled.svg'
import CheckboxChecked from '@/assets/icons/checkbox-checked.svg'
import CheckboxIndeterminate from '@/assets/icons/checkbox-indeterminate.svg'
import CheckboxUnchecked from '@/assets/icons/checkbox-unchecked.svg'
import Close from '@/assets/icons/close.svg'
import Collapsed from '@/assets/icons/collapsed.svg'
import Complete from '@/assets/icons/complete.svg'
import Delete from '@/assets/icons/delete.svg'
import Done from '@/assets/icons/done.svg'
import DownloadCase from '@/assets/icons/download-case.svg'
import DownloadDesign from '@/assets/icons/download-design.svg'
import Download from '@/assets/icons/download.svg'
import Duplicate from '@/assets/icons/duplicate.svg'
import Edit from '@/assets/icons/edit.svg'
import EmptyDeleted from '@/assets/icons/empty-deleted.svg'
import EmptyDesigns from '@/assets/icons/empty-designs.svg'
import EmptyTemplates from '@/assets/icons/empty-templates.svg'
import ErrorOutline from '@/assets/icons/error-outline.svg'
import Error from '@/assets/icons/error.svg'
import Expanded from '@/assets/icons/expanded.svg'
import Folder from '@/assets/icons/folder.svg'
import Generating from '@/assets/icons/generating.svg'
import LeftCube from '@/assets/icons/left-cube.svg'
import Logo from '@/assets/icons/logo.svg'
import Manage from '@/assets/icons/manage.svg'
import Maximise from '@/assets/icons/maximise.svg'
import Menu from '@/assets/icons/menu.svg'
import Minimise from '@/assets/icons/minimise.svg'
import MoreMenu from '@/assets/icons/more-menu.svg'
import MultipleSelected from '@/assets/icons/multiple-selected.svg'
import NoDesignIssues from '@/assets/icons/no-design-issues.svg'
import NoDesignsDownloaded from '@/assets/icons/no-designs-downloaded.svg'
import NoSearchResults from '@/assets/icons/no-search-results.svg'
import NoneSelected from '@/assets/icons/none-selected.svg'
import OfflineRework from '@/assets/icons/offline-rework.svg'
import Parts from '@/assets/icons/parts.svg'
import Processing from '@/assets/icons/processing.svg'
import Refresh from '@/assets/icons/refresh.svg'
import Rename from '@/assets/icons/rename.svg'
import Search from '@/assets/icons/search.svg'
import Settings from '@/assets/icons/settings.svg'
import SortAscend from '@/assets/icons/sort-ascend.svg'
import SortDescend from '@/assets/icons/sort-descend.svg'
import Sort from '@/assets/icons/sort.svg'
import SubmitForDesign from '@/assets/icons/submit-for-design.svg'
import SubscriptionInverse from '@/assets/icons/subscription-inverse.svg'
import SubscriptionRestriction from '@/assets/icons/subscription-restriction.svg'
import Subtract from '@/assets/icons/subtract.svg'
import Templates from '@/assets/icons/templates.svg'
import ToAccept from '@/assets/icons/to-accept.svg'
import ToDo from '@/assets/icons/to-do.svg'
import ToReview from '@/assets/icons/to-review.svg'
import Todo from '@/assets/icons/todo.svg'
import Unknown from '@/assets/icons/unknown.svg'
import Upload from '@/assets/icons/upload.svg'
import Users from '@/assets/icons/users.svg'
import View from '@/assets/icons/view.svg'
import Warning from '@/assets/icons/warning.svg'

export const AddPartsSvg = AddParts as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const AddSvg = Add as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CancelledSvg = Cancelled as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CheckboxCheckedSvg = CheckboxChecked as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CheckboxIndeterminateSvg = CheckboxIndeterminate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CheckboxUncheckedSvg = CheckboxUnchecked as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CloseSvg = Close as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CollapsedSvg = Collapsed as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const CompleteSvg = Complete as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DeleteSvg = Delete as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DoneSvg = Done as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DownloadCaseSvg = DownloadCase as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DownloadDesignSvg = DownloadDesign as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DownloadSvg = Download as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const DuplicateSvg = Duplicate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const EditSvg = Edit as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const EmptyDeletedSvg = EmptyDeleted as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const EmptyDesignsSvg = EmptyDesigns as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const EmptyTemplatesSvg = EmptyTemplates as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ErrorOutlineSvg = ErrorOutline as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ErrorSvg = Error as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ExpandedSvg = Expanded as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const FolderSvg = Folder as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const GeneratingSvg = Generating as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const LeftCubeSvg = LeftCube as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const LogoSvg = Logo as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ManageSvg = Manage as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const MaximiseSvg = Maximise as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const MenuSvg = Menu as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const MinimiseSvg = Minimise as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const MoreMenuSvg = MoreMenu as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const MultipleSelectedSvg = MultipleSelected as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const NoDesignIssuesSvg = NoDesignIssues as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const NoDesignsDownloadedSvg = NoDesignsDownloaded as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const NoSearchResultsSvg = NoSearchResults as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const NoneSelectedSvg = NoneSelected as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const OfflineReworkSvg = OfflineRework as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const PartsSvg = Parts as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ProcessingSvg = Processing as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const RefreshSvg = Refresh as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const RenameSvg = Rename as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SearchSvg = Search as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SettingsSvg = Settings as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SortAscendSvg = SortAscend as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SortDescendSvg = SortDescend as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SortSvg = Sort as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SubmitForDesignSvg = SubmitForDesign as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SubscriptionInverseSvg = SubscriptionInverse as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SubscriptionRestrictionSvg = SubscriptionRestriction as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const SubtractSvg = Subtract as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const TemplatesSvg = Templates as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ToAcceptSvg = ToAccept as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ToDoSvg = ToDo as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ToReviewSvg = ToReview as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const TodoSvg = Todo as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const UnknownSvg = Unknown as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const UploadSvg = Upload as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const UsersSvg = Users as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const ViewSvg = View as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
export const WarningSvg = Warning as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined
  }
>
